<footer class="bg-primary-footer py-4 dark:bg-contrast-black lg:py-9" role="contentinfo">
    <div class="max-content">
        <ng-container *ngIf="!env.FOOTER.HIDE_LOGO">
            <section class="-mx-1 hidden lg:block">
                <a class="inline-flex p-1" [routerLink]="'/home' | localize">
                    <img
                        class="pn-light-dark:h-12 jk-light-dark:h-12 h-6 dark:hidden"
                        alt="{{ 'ONBOARDING_LOGO_ALT' | translate }}"
                        src="{{ assetsPath$ | async }}/img/{{ logoFile }}" />
                    <img
                        class="pn-light-dark:h-12 jk-light-dark:h-12 hidden h-6 dark:block"
                        alt="{{ 'ONBOARDING_LOGO_ALT' | translate }}"
                        src="{{ assetsPath$ | async }}/img/{{ logoFileContrast }}" />
                </a>
            </section>
        </ng-container>

        <ul
            class="lg:mt-4 lg:grid lg:grid-cols-4 lg:gap-10"
            [ngClass]="{ 'lg:grid-cols-4': env.FOOTER.EXTRA_COLUMN, 'lg:grid-cols-3': !env.FOOTER.EXTRA_COLUMN }">
            <li>
                <div class="flex items-center justify-between lg:flex-col lg:items-start">
                    <h2 class="text-base font-bold">{{ 'FOOTER_COMPANY_NAME' | translate }}</h2>

                    <ul class="-mr-1 flex items-center gap-2 lg:-ml-1" *ngIf="footerSocialLinks">
                        <li *ngIf="footerSocialLinks.includes('facebook')">
                            <a
                                class="flex p-1"
                                target="_blank"
                                href="{{ 'FOOTER_FACEBOOK_URL' | translate }}"
                                rel="noopener">
                                <mat-icon
                                    class="!h-6 text-primary dark:filter-yellow lg:!h-5"
                                    svgIcon="facebook"></mat-icon>
                            </a>
                        </li>

                        <li *ngIf="footerSocialLinks.includes('youtube')">
                            <a
                                class="flex p-1"
                                target="_blank"
                                href="{{ 'FOOTER_YOUTUBE_URL' | translate }}"
                                rel="noopener">
                                <mat-icon
                                    class="!h-6 text-primary dark:filter-yellow lg:!h-5"
                                    svgIcon="youtube"></mat-icon>
                            </a>
                        </li>
                        <li *ngIf="footerSocialLinks.includes('twitter')">
                            <a
                                class="flex p-1"
                                target="_blank"
                                href="{{ 'FOOTER_TWITTER_URL' | translate }}"
                                rel="noopener">
                                <mat-icon
                                    class="!h-6 text-primary dark:filter-yellow lg:!h-5"
                                    svgIcon="twitter"></mat-icon>
                            </a>
                        </li>
                        <li *ngIf="footerSocialLinks.includes('instagram')">
                            <a
                                class="flex p-1"
                                target="_blank"
                                href="{{ 'FOOTER_INSTAGRAM_URL' | translate }}"
                                rel="noopener">
                                <mat-icon
                                    class="!h-6 text-primary dark:filter-yellow lg:!h-5"
                                    svgIcon="instagram"></mat-icon>
                            </a>
                        </li>
                        <li *ngIf="footerSocialLinks.includes('linkedin')">
                            <a
                                class="flex p-1"
                                target="_blank"
                                href="{{ 'FOOTER_LINKEDIN_URL' | translate }}"
                                rel="noopener">
                                <mat-icon
                                    class="!h-6 text-primary dark:filter-yellow lg:!h-5"
                                    svgIcon="linkedin"></mat-icon>
                            </a>
                        </li>
                    </ul>
                </div>

                <div
                    class="mt-2 text-sm lg:mt-4"
                    innerHtml="{{ 'FOOTER_ADDITIONAL_TEXT' | translate }}"
                    ridangoTranslatedLink></div>
            </li>

            <li class="mt-8 lg:mt-0" *ngIf="footerSupportActions">
                <h2 class="text-base font-bold">{{ 'FOOTER_CUSTOMER_SUPPORT' | translate }}</h2>

                <ul class="-mx-1 mt-1">
                    <li class="flex items-center text-sm" *ngIf="footerSupportActions.includes('mail')">
                        <mat-icon class="mx-1 text-[1rem]">mail</mat-icon>
                        <a class="inline-block p-1" href="{{ 'FOOTER_MAIL_US_LINK' | translate }}">
                            {{ 'FOOTER_MAIL_US' | translate }}
                        </a>
                    </li>
                    <li class="flex items-center text-sm" *ngIf="footerSupportActions.includes('phone')">
                        <mat-icon class="mx-1 text-[1rem]">call</mat-icon>
                        <a class="inline-block p-1" href="{{ 'FOOTER_PHONE_LINK' | translate }}">
                            {{ 'FOOTER_PHONE_TEXT' | translate }}
                        </a>
                    </li>
                    <li class="flex items-center text-sm" *ngIf="footerSupportActions.includes('feedback')">
                        <mat-icon class="mx-1 text-[1rem]">feedback</mat-icon>
                        <a
                            class="inline-block p-1"
                            href="{{ 'FOOTER_SUBMIT_FEEDBACK_LINK' | translate }}"
                            ridangoTranslatedLink>
                            {{ 'FOOTER_SUBMIT_FEEDBACK_TEXT' | translate }}
                        </a>
                    </li>
                    <li class="flex items-center text-sm" *ngIf="footerSupportActions.includes('report')">
                        <mat-icon class="mx-1 text-[1rem]">info</mat-icon>
                        <a class="inline-block p-1" [routerLink]="'/customer-support/report' | localize">
                            {{ 'EMV_SUPPORT_LINK' | translate }}
                        </a>
                    </li>
                    <li class="flex items-center text-sm" *ngIf="footerSupportActions.includes('FAQ')">
                        <mat-icon class="mx-1 text-[1rem]">chat</mat-icon>
                        <ng-container *ngIf="!helperService.isAllowedPath('/faq')">
                            <a class="inline-block p-1" [href]="'FOOTER_FAQ_LINK' | translate" target="_blank">
                                {{ 'FOOTER_FAQ_TEXT' | translate }}
                            </a>
                        </ng-container>
                        <ng-container *ngIf="helperService.isAllowedPath('/faq')">
                            <a class="inline-block p-1" [routerLink]="'/faq' | localize">
                                {{ 'FOOTER_FAQ_TEXT' | translate }}
                            </a>
                        </ng-container>
                    </li>
                    <li class="flex items-center text-sm" *ngIf="footerSupportActions.includes('CEMV_FAQ')">
                        <mat-icon class="mx-1 text-[1rem]">chat</mat-icon>
                        <ng-container *ngIf="!helperService.isAllowedPath('/cemv-faq')">
                            <a class="inline-block p-1" [href]="'FOOTER_CEMV_FAQ_LINK' | translate" target="_blank">
                                {{ 'FOOTER_CEMV_FAQ_TEXT' | translate }}
                            </a>
                        </ng-container>
                        <ng-container *ngIf="helperService.isAllowedPath('/cemv-faq')">
                            <a class="inline-block p-1" [routerLink]="'/cemv-faq' | localize">
                                {{ 'FOOTER_CEMV_FAQ_TEXT' | translate }}
                            </a>
                        </ng-container>
                    </li>
                    <li class="flex items-center text-sm" *ngIf="footerSupportActions.includes('card_info')">
                        <mat-icon class="mx-1 text-[1rem]">directions_bus</mat-icon>
                        <a class="inline-block p-1" [routerLink]="'/card-info' | localize">
                            {{ 'FOOTER_CARD_INFO_TEXT' | translate }}
                        </a>
                    </li>
                    <li class="flex items-center text-sm" *ngIf="footerSupportActions.includes('EXTERNAL_LINK')">
                        <mat-icon class="mx-1 text-[1rem]">chat</mat-icon>
                        <a class="inline-block p-1" [href]="'FOOTER_EXTERNAL_LINK' | translate" target="_blank">
                            {{ 'FOOTER_EXTERNAL_LINK_TEXT' | translate }}
                        </a>
                    </li>
                    <li class="flex items-center text-sm" *ngIf="footerSupportActions.includes('extra_row')">
                        <div innerHtml="{{ 'FOOTER_EXTRA_ROW' | translate }}"></div>
                    </li>
                    <li class="flex items-center text-sm" *ngIf="footerSupportActions.includes('switchCorp')">
                        <mat-icon class="mx-1 text-[1rem]">business_center</mat-icon>
                        <a class="inline-block p-1" href="{{ switchCorpLink }}">
                            {{ (env.IS_CORPORATE ? 'FOOTER_CUSTOMER_TEXT' : 'FOOTER_CORPORATE_TEXT') | translate }}
                        </a>
                    </li>
                </ul>
            </li>
            <li class="mt-7 lg:mt-0">
                <h2 class="text-base font-bold">{{ 'FOOTER_ACTIONS' | translate }}</h2>

                <ul
                    class="list-items -mx-1 mt-1 columns-2 lg:columns-1"
                    innerHtml="{{ 'FOOTER_ACTIONS_LIST' | translate }}"
                    ridangoTranslatedLink></ul>

                <ul class="list-items -mx-1 columns-2 lg:columns-1" ridangoTranslatedLink>
                    <ng-container *ngIf="isWebPurchaseAllowed && allowPurchaseLinksInFooter">
                        <ul
                            class="list-items"
                            innerHtml="{{ 'FOOTER_ACTIONS_LIST_WEB_PURCHASE_LINKS' | translate }}"
                            ridangoTranslatedLink></ul>
                    </ng-container>
                    <ng-container *ngIf="isLoginOrRegistrationAllowed && !ridangoAuth.getLoginStatus()">
                        <li>
                            <a [routerLink]="'/login' | localize">{{ 'FOOTER_LOG_IN' | translate }}</a>
                        </li>
                        <li>
                            <a [routerLink]="'/register' | localize">{{ 'FOOTER_REGISTER' | translate }}</a>
                        </li>
                    </ng-container>
                    <ng-container *ngIf="isLoginOrRegistrationAllowed && ridangoAuth.getLoginStatus()">
                        <li>
                            <a [routerLink]="'/account' | localize">{{ 'HEADER_MY_ACCOUNT' | translate }}</a>
                        </li>
                    </ng-container>
                    <ng-container *ngIf="footerSupportActions.includes('accessibility-notice')">
                        <li>
                            <a [routerLink]="'/accessibility-notice' | localize"
                                >{{ 'FOOTER_ACCESSIBILITY_NOTICE' | translate }}
                            </a>
                        </li>
                    </ng-container>
                </ul>
            </li>

            <li class="mt-7 lg:mt-0" *ngIf="env.FOOTER.EXTRA_COLUMN">
                <h2 class="text-base font-bold">{{ 'FOOTER_EXTRA_COLUMN_TITLE' | translate }}</h2>

                <ul
                    class="list-items -mx-1 mt-1 columns-2 lg:columns-1"
                    innerHtml="{{ 'FOOTER_EXTRA_COLUMN_CONTENT' | translate }}"
                    ridangoTranslatedLink></ul>
            </li>
        </ul>
    </div>
</footer>

<footer class="bg-white py-4" *ngIf="env.REGION_ID === 2" role="contentinfo">
    <div class="max-content">
        <img
            class="h-16 object-contain"
            src="{{ assetsPath$ | async }}/footer-logo.svg"
            alt="{{ 'LOGO' | translate }}"
            width="150"
            height="70" />
    </div>
</footer>
